import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Image } from '../Image/Image';

// Styles
import './image-slider-item.scss';

export const ImageSliderItem = ({ fluid }) => {
  return(
    <div className="image-slider-item">
      <div className="image-slider-item__image-container">
        <Image
          className="image-slider-item__image"
          fluid={fluid}
          position='absolute' />
      </div>
    </div>
  );
};

ImageSliderItem.propTypes = {
  fluid: PropTypes.object
};
